import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// LiveKit's component styles, then ours. Order matters: our stylesheet
// overrides parts of the LiveKit theme.
import '@livekit/components-styles';
import './styles/index.css';

import { App } from './App';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
